import { startsWith } from 'lodash';
import envConfig from '../../static/config';
import config from '../config';
import ApiUtils from './ApiUtils';
import MessageActionCreator from '../actions/MessageActionCreator';

/**
 * @note
 * This was previously just `/ibapi/v2/banks/{bank-id}/securemessages`
 * Which retrieved both the count of secure message *and* all the messages
 * themselves. This was entirely wasteful as we don't use the message content
 * in iB, and taxed on our backend heavily. – KW 16/02/2024
 */
const _getSecureMessageCountEndpoint =
  '/ibapi/v2/banks/{bank-id}/securemessages/count';

/**
 * API call for getMessages.
 * Retrieves the list of Messages for a customer.
 */
export function getMessageCount() {
  // if (envConfig.stubConfig) {
  // 	url = envConfig.stubConfig.messageStub.GetMessageCount;
  // }
  // let	url = 'http://localhost:3000/stubs/message-stub/GetMessageCount.json';
  ApiUtils.makeAjaxCall(
    {
      apiVersion: '1.2.0',
      method: 'GET',
      url: envConfig.apiBaseUrlPAAS + _getSecureMessageCountEndpoint,
      addAuthToken: true,
    },
    /* Update the MessageStore `messageCount` with the value recieved. */
    (body, status) =>
      MessageActionCreator.handleMessageCountSuccess(body, status),
    (error, status) => {
      if (
        status === 401 &&
        startsWith(
          error.headers[config.authenticateHeaderName],
          'Bearer realm error=tsandcs'
        )
      ) {
        setTimeout(getMessageCount, 5000);
      } else if (status === 403) {
        MessageActionCreator.navigateToWebTask('WEB-NONBCUSTOMERERROR');
      } else {
        MessageActionCreator.handleMessageCountError();
      }
    }
  );
}
